<div class="products-list-skeleton">
    <!-- Header Skeleton -->
    <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-auto text-center text-md-start">
            <app-skeleton-rect width="200px" height="28px" class="mb-2 d-inline-block"></app-skeleton-rect>
            <app-skeleton-rect width="150px" height="16px" class="d-block mx-auto mx-md-0"></app-skeleton-rect>
        </div>
        <div class="col-12 col-md-auto ms-md-auto d-flex justify-content-center justify-content-md-end gap-2">
            <app-skeleton-rect width="120px" height="38px" [borderRadius]="'8px'"></app-skeleton-rect>
            <app-skeleton-rect width="100px" height="38px" [borderRadius]="'8px'"></app-skeleton-rect>
        </div>
    </div>

    <!-- Filters Card Skeleton -->
    <div class="card mb-3">
        <div class="card-body py-3">
            <div class="row">
                <div class="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0">
                    <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                </div>
                <div class="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0">
                    <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                </div>
                <div class="col-12 col-sm-6 col-lg-3 mb-2 mb-lg-0">
                    <app-skeleton-rect width="100%" height="38px" class="d-block"></app-skeleton-rect>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <app-skeleton-rect width="100px" height="38px" class="d-block"></app-skeleton-rect>
                </div>
            </div>
        </div>
    </div>

    <!-- Table Card Skeleton -->
    <div class="card">
        <div class="card-body">
            <!-- Search & Pagination Header -->
            <div class="d-flex justify-content-between mb-3">
                <app-skeleton-rect width="250px" height="32px"></app-skeleton-rect>
                <app-skeleton-rect width="150px" height="32px"></app-skeleton-rect>
            </div>

            <!-- Table Header -->
            <div class="table-header d-flex align-items-center py-2 px-2 mb-2">
                <app-skeleton-rect width="50px" height="20px" class="me-3"></app-skeleton-rect>
                <app-skeleton-rect width="200px" height="20px" class="me-auto"></app-skeleton-rect>
                <app-skeleton-rect width="80px" height="20px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="120px" height="20px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="60px" height="20px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="80px" height="20px"></app-skeleton-rect>
            </div>

            <!-- Table Rows -->
            <ng-container *ngFor="let i of [0,1,2,3,4]">
                <div class="table-row d-flex align-items-center py-3 px-2">
                    <!-- Product Image & Name -->
                    <div class="d-flex align-items-center me-auto" style="min-width: 280px;">
                        <app-skeleton-rect width="50px" height="50px" [borderRadius]="'8px'"
                            class="me-3"></app-skeleton-rect>
                        <app-skeleton-rect width="180px" height="18px"></app-skeleton-rect>
                    </div>
                    <!-- Price -->
                    <app-skeleton-rect width="70px" height="18px" class="me-4"></app-skeleton-rect>
                    <!-- Categories -->
                    <app-skeleton-rect width="100px" height="18px" class="me-4"></app-skeleton-rect>
                    <!-- Stock -->
                    <app-skeleton-rect width="50px" height="18px" class="me-4"></app-skeleton-rect>
                    <!-- Status -->
                    <app-skeleton-rect width="80px" height="24px" [borderRadius]="'12px'"></app-skeleton-rect>
                </div>
            </ng-container>

            <!-- Pagination Footer -->
            <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                <app-skeleton-rect width="120px" height="20px"></app-skeleton-rect>
                <div class="d-flex gap-2">
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                </div>
            </div>
        </div>
    </div>
</div>